import { CustomTooltip } from '@fountain/fountain-ui-components';
import { Icon, InformationCircleOutlineIcon } from '@fountain/ripple/icon';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';

export interface InfoTooltipProps {
  title: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const InfoTooltip: FC<InfoTooltipProps> = ({ title, ...otherProps }) => {
  const intl = useIntl();

  return (
    <CustomTooltip title={title} dense {...otherProps}>
      <Icon
        icon={InformationCircleOutlineIcon}
        size="sm"
        color="neutral-400"
        role="img"
        aria-label={intl.formatMessage(messages.infoIcon)}
      />
    </CustomTooltip>
  );
};
